export function Logo() {
  return (
    <div className="flex items-center gap-x-[6px]" data-testid="logo">
      <svg width="90" height="13" viewBox="0 0 90 13" fill="none">
        <title>Rarible Logo</title>
        <g style={{ mixBlendMode: "normal" }}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0.522461V12.5225H3.63695V8.41873H8.88817L10.7747 12.5225H14.4311L12.2528 7.89361L13.8865 6.2599V2.68129L11.7083 0.522461H0ZM9.66613 5.65698H3.63695V3.28421H9.66613L10.3468 3.96493V4.97627L9.66613 5.65698Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0038 12.5225L19.2048 0.522461H25.1172L29.3182 12.5225H25.8563L24.7477 9.66347H19.5743L18.4657 12.5225H15.0038ZM20.4884 6.86282H23.8336L22.5111 3.26476H21.8109L20.4884 6.86282Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.9081 0.522461V12.5225H33.545V8.41873H38.7962L40.6828 12.5225H44.3392L42.1609 7.89361L43.7946 6.2599V2.68129L41.6163 0.522461H29.9081ZM39.5742 5.65698H33.545V3.28421H39.5742L40.2549 3.96493V4.97627L39.5742 5.65698Z"
            fill="white"
          />
          <path
            d="M45.1597 12.5225V11.3361L45.1208 2.4868V0.522461H48.6216V2.4868H48.6022L48.5633 11.3361V12.5225H45.1597Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M49.787 0.522461V12.5225H61.8648L64.0237 10.3636V7.77692L62.4872 6.3377L63.4596 5.3458V2.68129L61.3008 0.522461H49.787ZM59.2976 5.3069H53.424V3.28421H59.2976L59.9783 3.96493V4.62619L59.2976 5.3069ZM59.706 9.76071H53.424V7.83526H59.706L60.3867 8.51598V9.08L59.706 9.76071Z"
            fill="white"
          />
          <path
            d="M65.0947 12.5225V0.522461H68.7317V9.56622H75.3054V12.5225H65.0947Z"
            fill="white"
          />
          <path
            d="M76.3819 12.5225V0.522461H89.2182V3.4787H80.0189V5.15131H88.4986V7.89361H80.0189V9.56622H89.2182V12.5225H76.3819Z"
            fill="white"
          />
        </g>
      </svg>
    </div>
  )
}

export function GachaLogo() {
  return (
    <div className="flex items-center" data-testid="gacha-logo">
      <img
        src="/images/gacha/rarible-gacha.svg"
        alt="Rarible Gacha"
        className="h-[18px] w-auto"
      />
    </div>
  )
}
